import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../configs/urlConfig";
import Utils from "../utils";
axios.defaults.withCredentials = true;

function CustomerInvestmentModal({ onClose, onSave, customer }) {

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    existing_customer: "", // za select
    first_name: "",        // ako dodaje novu
    deposit_date: new Date().toISOString().split("T")[0], // default na danas
    invested_amount: "",
    payout: "",
    payout_percentage: "",
  });
  useEffect(() => {
    if (customer?.id !== '') {
      setForm({ ...form, existing_customer: customer.id })

    }
  }, [customer])


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const payload = { ...form };

      // Ako je izabran existing_customer, ignorisi first_name
      if (form.existing_customer) {
        delete payload.first_name;
      }

      const response = await axios.post(`${API}/customer-create/`, payload, Utils.getUserToken());

      if (response.data.success) {
        onSave && onSave(response.data.customer);
        onClose();
      } else {
        setError(response.data.error || "Greška prilikom čuvanja mušterije");
      }
    } catch (err) {
      console.error(err);
      setError("Greška prilikom čuvanja mušterije");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      aria-labelledby="customerModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
        <div className="modal-content app-modal">
          <div className="modal-header border-0">
            <div>
              <h2 className="modal-title fs-4" id="customerModalLabel">
                Nova uplata za {customer.name}
              </h2>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Zatvori"
            ></button>
          </div>

          {error && <div className="alert alert-danger m-3">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="modal-body pt-0">
              <div className="row g-3">


                <div className="col-12 col-md-6">
                  <label className="form-label">Ime</label>
                  <input
                    readOnly
                    type="text"
                    name="first_name"
                    className="form-control"
                    value={customer.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">Datum uplate</label>
                  <input
                    type="date"
                    name="deposit_date"
                    className="form-control"
                    value={form.deposit_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">Iznos</label>
                  <input
                    type="number"
                    name="invested_amount"
                    className="form-control"
                    value={form.invested_amount}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">Povrat</label>
                  <input
                    type="number"
                    name="payout"
                    className="form-control"
                    value={form.payout}
                    onChange={handleChange}
                  />
                </div>

                {/* <div className="col-12">
                    <label className="form-label">Procenat povrata</label>
                    <input
                      type="number"
                      name="payout_percentage"
                      className="form-control"
                      value={form.payout_percentage}
                      onChange={handleChange}
                    />
                    <div className="form-text">
                      Unesi procenat mesečnog povrata
                    </div>
                  </div> */}
              </div>

            </div>

            <div className="modal-footer border-0 modal-footer-stack">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Zatvori
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Čuvanje..." : "Sačuvaj Uplatu"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CustomerInvestmentModal;